import { ImpactCalculator } from "./ImpactCalculator";
import { useDonationFormStore } from "@/stores";
import type { ImpactCalculatorWithStoreProps } from "./ImpactCalculatorProps";

export function ImpactCalculatorWithStore({
  config,
  className,
}: ImpactCalculatorWithStoreProps) {
  const { donationAmount, donationType } = useDonationFormStore();

  return (
    <ImpactCalculator
      amount={donationAmount ?? 0}
      isMonthly={donationType === "monthly"}
      config={config}
      className={className}
    />
  );
}
